module.exports = __webpack_public_path__ + "static/media/Icon awesome-play.d20dbc16.svg";